import { Modal, ModalFooter } from 'components/Modal'
import * as React from 'react'
import { DefaultContent } from 'react-content-engine'
import { createPortal } from 'react-dom'
import { connect } from 'react-redux'
import { actions } from 'react-redux-form'
import { match as urlMatch } from 'react-router'
import { Theme } from '../../data/models/funnelOrder/theme'
import { displayedCountries, SiteCountry } from '../../data/models/locale'
import { AppState } from '../../data/state'
import { getLinkName, Slink, Sredirect } from '../../routing/links'
import Content from './content'

interface CountrySelectProps {
  country: SiteCountry
  match: urlMatch<any>
  showConfirmation?: boolean
  theme: Theme

  resetFunnelOrder(): void
}

interface CountrySelectState {
  showConfirmationModal: boolean
  redirectCountryCode: SiteCountry | null
  redirect: boolean
}

class MenuCountrySelect extends React.Component<
  CountrySelectProps,
  CountrySelectState
> {
  constructor(props: CountrySelectProps) {
    super(props)
    this.state = {
      showConfirmationModal: false,
      redirectCountryCode: null,
      redirect: false,
    }
  }

  public confirmationModal() {
    const dismiss = () => this.setState({ showConfirmationModal: false })
    return (
      <Modal onDismiss={dismiss}>
        <div className="content">
          <Content contentKey="confirm-country-change">
            Are you sure you want to change country? This action will reset your
            order.
          </Content>
        </div>
        <ModalFooter
          onClose={dismiss}
          saveText={
            <DefaultContent contentKey="yes-save">Yes, save</DefaultContent>
          }
          onSave={() => {
            this.props.resetFunnelOrder()
            this.setState({
              showConfirmationModal: false,
              redirect: true,
            })
          }}
        />
      </Modal>
    )
  }

  public render() {
    const { country, match } = this.props
    const name = getLinkName(match.url)

    if (
      this.state.redirect === true &&
      this.state.redirectCountryCode !== null
    ) {
      if (this.props.showConfirmation) {
        return (
          <Sredirect
            name={
              this.props.theme === Theme.drive
                ? 'drivecustomise'
                : 'flycustomise'
            }
            country={this.state.redirectCountryCode}
          />
        )
      }
      return (
        <Sredirect
          name={name}
          params={match.params}
          country={this.state.redirectCountryCode}
        />
      )
    }

    return (
      <>
        {this.state.showConfirmationModal
          ? createPortal(
              this.confirmationModal(),
              document.getElementsByTagName('main')[0],
            )
          : null}
        {displayedCountries.map(countryCode =>
          countryCode !== country ? (
            <li key={countryCode} className="locale-otherLanguage">
              {this.props.showConfirmation ? (
                <a
                  onClick={() =>
                    this.setState({
                      redirectCountryCode: countryCode,
                      showConfirmationModal: true,
                    })
                  }
                >
                  {countryCode}
                </a>
              ) : (
                <Slink name={name} params={match.params} country={countryCode}>
                  {countryCode}
                </Slink>
              )}
            </li>
          ) : null,
        )}
      </>
    )
  }
}

const mapStateToProps = (state: AppState) => ({
  country: state.locale.country,
  theme: state.funnelOrder.theme,
})

const mapDispatchToProps = (dispatch: any) => ({
  resetFunnelOrder: () => {
    dispatch(actions.reset('funnelOrder'))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(MenuCountrySelect)
